import React from 'react';
import '../../styles/utilities/spacing.css';
import '../../styles/utilities/typography.css';
import '../../styles/utilities/layout.css';

interface HeroCardProps {
  title: string;
  subtitle: string;
  appStoreUrl: string;
}

const HeroCard: React.FC<HeroCardProps> = ({
  title,
  subtitle,
  appStoreUrl
}) => {
  return (
    <div className="card hero-card">
      <div className="hero-content">
        <div className="hero-left">
          <div className="lut-roll-container">
            <img
              src="assets/lut-roll-ios.png"
              alt="LUT Rolls App Icon"
              className="lut-roll-icon"
            />
          </div>
          
          <h1 style={{
            fontSize: '4rem', 
            lineHeight: 1,
            textAlign: 'inherit' // Inherit from .hero-left parent
          }}>{title}</h1>
          <h3 style={{fontSize: '2.25em', fontWeight: 500,
lineHeight: 1.2}}>
            {subtitle}
            </h3>
          
          <p style={{fontSize: '1.4rem', fontWeight: 500, lineHeight: 1.5, margin: '1.5rem 0'}}>
Enhance photos on iPhone with curated filters and effects inspired by film, fashion, and fine art. Swipe to browse, tap to apply, and fine-tune in seconds.
            <br />
            <br />
From street scenes and architecture to food, pets, and concerts, create a look that feels like yours.
          </p>
          
          <div className="app-store-container">
            <a 
              href={appStoreUrl}
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-link"
              onClick={(e) => {
                console.log('App Store link clicked!');
                // Let the default behavior continue
              }}
            >
              <img 
                src="assets/downloadButtonAppStore.svg" 
                alt="Download on App Store" 
                className="app-store-image" 
              />
            </a>
          </div>
        </div>
        
        <div className="hero-right">
          <img 
            src="assets/lutrolls-mockup.png" 
            alt="LUT Rolls App Preview" 
            className="hero-image-device" 
          />
        </div>
      </div>
    </div>
  );
};

export default HeroCard; 